<kendo-drawer-container>
  <kendo-drawer
    [mode]="drawerMode"
    [(expanded)]="expanded"
    [className]="'drawer'"
    [width]="260"
    [mini]="false"
  >
    <ng-template kendoDrawerTemplate>
      <div class="drawer-menu">
        <h1 class="menu-nav-title">{{ "menu_nav_title_text" | i18n }}</h1>
        <hr class="k-hr" />

        <div class="nav-group">
          <h4 class="h4 mt-3 mt-sm-5">
            {{ "menu_nav_dashboard_title_text" | i18n }}
          </h4>
          <ul class="nav nav-list flex-column">
            <li class="nav-item">
              <a
                class="nav-link"
                href="javascript: void(0);"
                (click)="navClick.emit('toDashboard')"
                >{{ "menu_nav_dashboard_circulations_text" | i18n }}</a
              >
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                href="javascript: void(0);"
                (click)="navClick.emit('toTemplates')"
                >{{ "menu_nav_dashboard_templates_text" | i18n }}</a
              >
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                href="javascript: void(0);"
                (click)="navClick.emit('toTasks')"
                >{{ "menu_nav_dashboard_tasks_text" | i18n }}</a
              >
            </li>
          </ul>
        </div>
        <!-- { groups: [ { items: [], displayName}] }-->
        <div class="nav-group">
          <h4 class="h4 mt-3 mt-sm-5">
            {{ "menu.nav.action.title.text" | i18n }}
          </h4>
          <ul class="nav nav-list flex-column">
            <li
              class="nav-item"
              [title]="
                ('create' | isNotAblePure: 'circulation' | async)
                  ? ('menu.nav.action.newCirculation.permissionText' | i18n)
                  : ('menu.nav.action.newCirculation.tooltip' | i18n)
              "
            >
              <a
                [class.disabled]="
                  'create' | isNotAblePure: 'circulation' | async
                "
                class="nav-link"
                href="javascript: void(0);"
                (click)="navClick.emit('toCirculationCreation')"
              >
                {{ "menu.nav.action.newCirculation.text" | i18n }}</a
              >
            </li>
            <li
              class="nav-item"
              [title]="
                ('createcirculation' | isNotAblePure: 'template' | async)
                  ? ('menu.nav.action.newCirculationFromTemplate.permissionText'
                    | i18n)
                  : ('menu.nav.action.newCirculationFromTemplate.tooltip'
                  | i18n)
              "
            >
              <a
                [class.disabled]="
                  'createcirculation' | isNotAblePure: 'template' | async
                "
                class="nav-link"
                href="javascript: void(0);"
                (click)="navClick.emit('toCirculationCreationFromTemplate')"
              >
                {{
                  "menu.nav.action.newCirculationFromTemplate.text" | i18n
                }}</a
              >
            </li>
            <li
              class="nav-item"
              [title]="
                ('startmultiple' | isNotAblePure: 'circulation' | async)
                  ? ('menu.nav.action.startMultipleCirculations.permissionText'
                    | i18n)
                  : ('menu.nav.action.startMultipleCirculations.tooltip'
                  | i18n)
              "
            >
              <a
                [class.disabled]="
                  'startmultiple' | isNotAblePure: 'circulation' | async
                "
                class="nav-link"
                href="javascript: void(0);"
                (click)="navClick.emit('toCirculationStartMultiple')"
              >
                {{
                  "menu.nav.action.startMultipleCirculations.text" | i18n
                }}</a
              >
            </li>
            <li
              class="nav-item"
              [title]="
                ('create' | isNotAblePure: 'template' | async)
                  ? ('menu.nav.action.newTemplate.permissionText' | i18n)
                  : ('menu.nav.action.newTemplate.tooltip' | i18n)
              "
            >
              <a
                [class.disabled]="'create' | isNotAblePure: 'template' | async"
                class="nav-link"
                href="javascript: void(0);"
                (click)="navClick.emit('toTemplateCreation')"
              >
                {{ "menu.nav.action.newTemplate.text" | i18n }}</a
              >
            </li>
            <li
            class="nav-item"
            [title]="'menu.nav.action.manageSubstitute.title' | i18n"
          >
            <a
              class="nav-link"
              href="javascript: void(0);"
              (click)="navClick.emit('toUserSubstitute')"
            >
              {{ "menu.nav.action.manageSubstitute.text" | i18n }}</a
            >
          </li>
          </ul>
        </div>
        <div class="nav-group" *ngIf="'read' | isAblePure: 'Substitute' | async">
          <h4 class="h4 mt-3 mt-sm-5">
            {{ "menu.nav.substitute.title.text" | i18n }}
          </h4>
          <ul class="nav nav-list flex-column">
            <li *ngFor="let item of substituteLinks"
              class="nav-item"
              [title]=" item.title | i18n "
              >
              <a
              class="nav-link"
              href="javascript: void(0);"
              (click)="navClick.emit(item.emitValue)"
            >
              {{ item.text | i18n }}</a
            >
            </li>
          </ul>
        </div>
        <div class="nav-group" *ngIf="'read' | isAblePure: 'Admin' | async">
          <h4 class="h4 mt-3 mt-sm-5">
            {{ "menu_nav_admin_title_text" | i18n }}
          </h4>
          <ul class="nav nav-list flex-column">
            <li *ngFor="let item of adminLinks"
              class="nav-item"
              [title]=" item.title | i18n "
              >
              <a
              class="nav-link"
              href="javascript: void(0);"
              (click)="navClick.emit(item.emitValue)"
            >
              {{ item.text | i18n }}</a
            >
            </li>
          </ul>
        </div>
      </div>
    </ng-template>
  </kendo-drawer>
  <kendo-drawer-content>
    <ng-content></ng-content>
  </kendo-drawer-content>
</kendo-drawer-container>
